import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// 모든 토픽 목록 가져오기
// complete
export const fetchTopics = createAsyncThunk('topics/fetchTopics', async () => {
  const response = await axios.get('/api/topics');
  return response.data;
});

// 특정 토픽 하나만 서버에서 가져오기 (새로고침 시 필수)
export const fetchTopicDetail = createAsyncThunk(
  'topics/fetchTopicDetail',
  async (topicId) => {
    const response = await axios.get(`/api/topics/${topicId}`);
    return response.data;
  }
);

export const createTopic = createAsyncThunk(
  'topics/createTopic',
  async (newTopic, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');

      console.log("token in createTopic:", token);
      
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      const response = await axios.post('../api/topics', newTopic, config);
      
      return response.data;

    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const topicsSlice = createSlice({
  name: 'topics',
  initialState: { 
    list: [], 
    current: null, 
    isLoading: true,
    error: null 
  },
  reducers: {
    setCurrentTopic: (state, action) => { 
      state.current = action.payload; 
    }
  },
  extraReducers: (builder) => {
    builder
      // 전체 목록 로딩 처리
      .addCase(fetchTopics.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTopics.fulfilled, (state, action) => {
        state.list = action.payload;
        state.isLoading = false;
      })
      // 특정 토픽 상세 로딩 처리 (새로고침 해결사)
      .addCase(fetchTopicDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTopicDetail.fulfilled, (state, action) => {
        state.current = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchTopicDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // 새 토픽 생성 처리
      .addCase(createTopic.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(createTopic.rejected, (state, action) => {
        state.error = action.payload.message;
      });
  }
});

export const { setCurrentTopic } = topicsSlice.actions;
export default topicsSlice.reducer;